import { TranslateFunction } from '@griply/types';

// Only these can be missing from a month, so only these need the "shortest month" warning.
const END_OF_MONTH_DAYS = [29, 30, 31];

export const getMonthDayWarning = (
  selectedMonthDays: number[],
  t: TranslateFunction,
): string | null => {
  const lastSelectedDays = END_OF_MONTH_DAYS.filter((day) =>
    selectedMonthDays.includes(day),
  );

  if (!lastSelectedDays.length) {
    return null;
  }

  const formatOrdinal = (day: number) => t(`general.labels.${day}.ordinal`);
  const amount = lastSelectedDays[lastSelectedDays.length - 1];

  const days =
    lastSelectedDays.length === 1
      ? formatOrdinal(lastSelectedDays[0])
      : `${lastSelectedDays.slice(0, -1).map(formatOrdinal).join(', ')} ${t(
          'general.labels.habit.repeat.and',
        )} ${formatOrdinal(amount)}`;

  return t('general.labels.habit.repeat.month-day-warning', {
    count: lastSelectedDays.length,
    days,
    amount,
  });
};
